import { container } from 'src/StaticContainer';

export * from '@thinkalpha/ui-core/appError/AppError';

// TODO: Should we expose an `ErrorService` for tracking errors generically?
export function trackError(error: Error, rest?: Record<string, unknown>) {
    container.getOptional('DatadogService')?.submitErrorToDatadog(error, rest);
}
